module.exports = __webpack_public_path__ + "img/xian_d.85321a52.png";